const CartStoreSkeleton = () => {
    return (
        <div className="cartDiv">
            <h3 className="storeHdn cartStoreHdn">
                <div className="skeleton" style={{ width: 220, height: 32, borderRadius: 8 }} />
            </h3>

            <div className="cartLoop">
                <div className="cartEachLoop">
                    {Array.from({ length: 2 }).map((_, index) => (
                        <ul className="cartTable" key={`cart-skeleton-item-${index}`}>
                            <li>
                                <div className="imgCart">
                                    <div className="skeleton" style={{ width: 100, height: 120, borderRadius: 8 }} />
                                </div>
                                <div className="cartDtls" style={{ width: "100%" }}>
                                    <div className="skeleton" style={{ width: "55%", height: 20, marginBottom: 8 }} />
                                    <div className="skeleton" style={{ width: "30%", height: 16, marginBottom: 12 }} />
                                    <div className="cartQuantity">
                                        <div className="skeleton" style={{ width: 120, height: 36, borderRadius: 8 }} />
                                        <div className="skeleton" style={{ width: 90, height: 18 }} />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    ))}
                </div>

                <ul className="totalDiv">
                    <li className="PriceTtl">
                        <div className="skeleton" style={{ width: "45%", height: 16 }} />
                        <div className="skeleton" style={{ width: "35%", height: 16 }} />
                    </li>
                    <li className="PriceTtl">
                        <div className="skeleton" style={{ width: "52%", height: 16 }} />
                        <div className="skeleton" style={{ width: "35%", height: 16 }} />
                    </li>
                    <li className="PriceTtl prcMain">
                        <div className="skeleton" style={{ width: "40%", height: 18 }} />
                        <div className="skeleton" style={{ width: "40%", height: 18 }} />
                    </li>
                    <li>
                        <div className="cartDivBtns">
                            <div className="skeleton" style={{ width: 140, height: 42, borderRadius: 8 }} />
                            <div className="skeleton" style={{ width: 160, height: 42, borderRadius: 8 }} />
                        </div>
                    </li>
                </ul>
            </div>

            <div className="paymentTrms">
                <div className="skeleton" style={{ width: "45%", height: 14, marginBottom: 8 }} />
                <div className="skeleton" style={{ width: "38%", height: 14 }} />
            </div>
        </div>
    );
};

export default CartStoreSkeleton;
